<template>
     <v-sheet class="pa-5" width="100%">
        <AppYYMM :aplyMinDt="'2020-01'" :aplyMaxDt="$moment().format('YYYY-MM')" @sltHypDt="getHypDt"></AppYYMM>
        <v-divider class="mt-3 mb-4"></v-divider>
        <v-row class="pa-0" no-gutters>
            <span class="fontOneToOne font-weight-medium">근무현황</span>
        </v-row>
        <v-divider class="black mt-2"></v-divider>
        <v-row class="nmlBfClr-grey001 pa-0" no-gutters>
            <v-col class="txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="4">
                <span class="fontOne">근무유형</span>
            </v-col>
            <v-col class="txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="4">
                <span class="fontOne">근무상세</span>
            </v-col>
            <v-col class="txtAlgnMid pt-1" style="padding-bottom: 5px;" cols="4">
                <span class="fontOne">실 근무시간</span>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row v-for="(wrk, i) in actWrkList" :key="i" class="pa-0 tableBB" no-gutters>
            <v-col class="txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="4">
                <span class="fontOne">{{ wrk.wrkTypNm }}</span>
            </v-col>
            <v-col class="txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="4">
                <span class="fontOne">{{ wrk.vctnTypNm }}</span>
            </v-col>
            <v-col class="txtAlgnMid pt-1" style="padding-bottom: 5px;" cols="4">
                <span class="fontOne">{{ wrk.actWrkHrNm }}</span>
            </v-col>
        </v-row>
        <v-row v-if="actWrkList.length == 0" class="pa-0 tableBB" no-gutters>
            <v-col class="txtAlgnMid px-2 pt-2" style="padding-bottom: 10px;" cols="12">
                <span class="fontDotEight">조회된 근무 기록이 없습니다.</span>
            </v-col>
        </v-row>
        <v-divider class="white mt-2"></v-divider>
        <v-divider class=""></v-divider>
        <v-row class="nmlBfClr-grey001 pa-0" no-gutters>
            <v-col class="txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="8">
                <span class="fontOne">합계</span>
            </v-col>
            <v-col class="txtAlgnMid pt-1" style="padding-bottom: 5px;" cols="4">
                <span class="fontOne">{{ Math.floor(actWrkHrTot / 60) + '시간' + (actWrkHrTot % 60) + '분' }}</span>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-divider class="white my-2"></v-divider>
        <v-row class="pa-0 align-center" no-gutters>
            <span class="fontOneToOne font-weight-medium">연차정보</span>
            <v-spacer></v-spacer>
            <v-btn color="blue105" @click="isAnlHis = true" x-small outlined>
                <span>연차이력조회</span>
            </v-btn>
        </v-row>
        <v-divider class="black mt-2"></v-divider>
        <v-row class="pa-0" no-gutters>
            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="4">
                <span class="fontOne">근무연차</span>
            </v-col>
            <v-col class="px-4 pt-1" style="padding-bottom: 5px;" cols="8">
                <span class="fontOne">{{ actWrkInf.wrkAnlDesc }}</span>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="pa-0" no-gutters>
            <v-col
                class="nmlBfClr-grey001 txtAlgnMid tableBR"
                style="padding-top: 18px; padding-bottom: 5px; line-height: 1.3;"
                cols="4">
                <span class="fontOne">발생연차</span>
            </v-col>
            <v-col class="px-4 pt-1" style="padding-bottom: 5px;" cols="8">
                <span class="fontOne">{{ actWrkInf.anlDys }}일</span>
                <br>
                <span class="fontOne">&#40; 발생일: {{ actWrkInf.anlOcrDtNm }} &#41;</span>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="pa-0" no-gutters>
            <v-col
                class="nmlBfClr-grey001 txtAlgnMid tableBR"
                style="padding-top: 18px; padding-bottom: 5px; line-height: 1.3;"
                cols="4">
                <span class="fontOne">사용연차</span>
            </v-col>
            <v-col class="px-4 pt-1" style="padding-bottom: 5px;" cols="8">
                <span class="fontOne">{{ actWrkInf.anlUseCnt }}일</span>
                <br>
                <span class="fontOne">&#40; 기준일: {{ $moment().format('YYYY.MM.DD') }} &#41;</span>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="pa-0" no-gutters>
            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="4">
                <span class="fontOne">차감연차</span>
            </v-col>
            <v-col class="px-4 pt-1" style="padding-bottom: 5px;" cols="8">
                <span class="fontOne">{{ actWrkInf.ddcDys }}일</span>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="pa-0" no-gutters>
            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR pt-1" style="padding-bottom: 5px;" cols="4">
                <span class="fontOne">잔여연차</span>
            </v-col>
            <v-col class="px-4 pt-1" style="padding-bottom: 5px;" cols="8">
                <span class="fontOne">{{ actWrkInf.rmnAnl }}일</span>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-dialog v-model="isAnlHis" eager>
            <v-sheet
                class="ma-0 pa-4" rounded="lg">
                <v-row class="pa-0" no-gutters>
                    <v-col class="d-flex align-center" cols="10">
                        <span class="font-weight-medium fontOneToTwo">연차 이력</span>
                    </v-col>
                    <v-col class="d-flex" cols="2">
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="isAnlHis = false"
                            style="margin-top: 2px;" icon>
                            <v-icon class="grey006--text" size="30">mdi-close</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-divider class="mt-3 mb-2"></v-divider>
                <div v-for="(anl, i) in empUseAnlList" :key="i">
                    <v-row class="pa-0" no-gutters>
                        <v-col class="grey006--text px-3" cols="4">
                            <span class="font-weight-medium fontOneRem">사용일</span>
                        </v-col>
                        <v-col class="grey006--text txtAlgnEnd px-3" cols="8">
                            <span class="fontOneRem">{{ anl.anlDtDot }}</span>
                        </v-col>
                        <v-col class="grey006--text px-3 pt-1" cols="4">
                            <span class="font-weight-medium fontOneRem">종류</span>
                        </v-col>
                        <v-col class="grey006--text txtAlgnEnd px-3" cols="8">
                            <span class="fontOneRem">{{ anl.useClcdNm }}</span>
                        </v-col>
                        <v-col class="grey006--text px-3 pt-1" cols="4">
                            <span class="font-weight-medium fontOneRem">비고</span>
                        </v-col>
                        <v-col class="grey006--text txtAlgnEnd px-3" cols="8">
                            <span v-if="anl.rmrks == ''" class="fontOneRem">-</span>
                            <span v-else class="fontOneRem">{{ anl.rmrks }}</span>
                        </v-col>
                    </v-row>
                    <v-divider class="my-2"></v-divider>
                </div>
                <div v-if="empUseAnlList.length == 0">
                    <v-row class="pa-0 mx-2 tableBB" no-gutters>
                        <v-col class="txtAlgnMid px-2 pt-2 pb-4" cols="12">
                            <span class="fontDotEight">연차사용 내역이 없습니다.</span>
                        </v-col>
                    </v-row>
                </div>
            </v-sheet>
        </v-dialog>
     </v-sheet>
</template>

<script>
import { http } from '@/assets/js/baseAxios';

import AppYYMM from '../cmm/AppYYMM.vue';

export default {
    name: 'EmpAnlInf',

    components: {
        AppYYMM,
    },

    props: {

    },

    created: function(){

    },

    mounted: function(){
        this.$nextTick(function () {
            this.$parent.$parent.appBarTtl = '직원 연차 정보'
            //this.sltHypDt = this.$store.getters.getPrsntDt('yyyy-mm-dd')

            this.getEmpAnlUseInf(this.$moment().format('YYYYMM'))
            this.getEmpUseAnlList()
        })
    },

    computed: {

    },

    watch:{
        
    },
        
    methods: {
        // 직원 연차 정보 조회
        getEmpAnlUseInf: function (yymm){
            this.actWrkHrTot = 0
            this.rstActWrkInf()
            this.actWrkList.splice(0)
            this.$store.commit('setCmmLdrCricle', true)

            http.post('empApp/selEmpAnlUseInfo', { inqYYMM: yymm })
                .then((response) => ( this.empAnlUseRst(response.data) ))
                .catch((error) => console.log('axios error /empApp/selEmpAnlUseInfo : ' + error))
        },

        empAnlUseRst: function (res){
            if(res.statusCode == '200'){
                this.actWrkInf.wrkAnlDesc = res.result.info.wrkAnlDesc
                this.actWrkInf.anlDys = res.result.info.anlDys
                this.actWrkInf.anlUseCnt = res.result.info.anlUseCnt
                this.actWrkInf.ddcDys = res.result.info.ddcDys
                this.actWrkInf.rmnAnl = res.result.info.rmnAnl
                if(res.result.info.anlOcrDt == null) res.result.info.anlOcrDt = ''
                if(res.result.info.anlOcrDt != '')
                    this.actWrkInf.anlOcrDtNm = this.$moment(res.result.info.anlOcrDt, 'YYYYMMDD').format('YYYY.MM.DD')

                res.result.list.forEach(itm => {
                    this.actWrkHrTot += itm.actWrkHr
                    itm.actWrkHrNm = Math.floor(itm.actWrkHr / 60) + '시간' + (itm.actWrkHr % 60) + '분'
                });

                this.actWrkList = res.result.list
            }

            this.$store.commit('setCmmLdrCricle', false)
        },

        // 직원 연차 이력 조회
        getEmpUseAnlList: function (){
            this.empUseAnlList.splice(0)
            this.$store.commit('setCmmLdrCricle', true)

            http.post('empApp/selEmpUseAnlList', { })
                .then((response) => ( this.empUseAnlRst(response.data) ))
                .catch((error) => console.log('axios error /empApp/selEmpUseAnlList : ' + error))
        },

        empUseAnlRst: function (res){
            if(res.statusCode == '200'){
                res.result.list.forEach(itm => {
                    if(itm.rmrks == null) itm.rmrks = ''
                    if(itm.anlDt == null) itm.anlDt = ''
                    if(itm.anlDt != null)
                        itm.anlDtDot = this.$moment(itm.anlDt, 'YYYYMMDD').format('YYYY.MM.DD')
                    else
                        itm.anlDtDot = ''

                    if(itm.useClcd == '1')
                        itm.useClcdNm = '사용연차'
                    else if(itm.useClcd == '2')
                        itm.useClcdNm = '차감연차'
                    else
                        itm.useClcdNm = ''

                });

                this.empUseAnlList = res.result.list
            }
            
            this.$store.commit('setCmmLdrCricle', false)
        },

        getHypDt: function (v){
            this.getEmpAnlUseInf(this.$moment(v, 'YYYY-MM').format('YYYYMM'))
        },

        rstActWrkInf: function (){
            this.actWrkInf.wrkAnlDesc = ''
            this.actWrkInf.anlDys = 0
            this.actWrkInf.anlUseCnt = 0
            this.actWrkInf.ddcDys = 0
            this.actWrkInf.mnAnl = 0
        },
    },

    data: () => ({
        isAnlHis: false,
        actWrkHrTot: 0,
        actWrkList: [],
        empUseAnlList: [],
        actWrkInf: {
            wrkAnlDesc: '', anlDys: 0, anlUseCnt: 0, ddcDys: 0, rmnAnl: 0, anlOcrDt: '', anlOcrDtNm: ''
        },
    }),
};
</script>